module.exports = __webpack_public_path__ + "img/13-small.98a00e26.png";